import { Component, OnInit } from '@angular/core';
import { printReportLabel } from 'app/constants/csv/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { DateService, HelperService, HTTPService } from 'app/services';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-print-log-dialog',
  templateUrl: './print-log-dialog.component.html',
  styleUrls: ['./print-log-dialog.component.scss'],
  providers: [DialogService],
})
export class PrintLogDialogComponent implements OnInit {
  printLogs: any;
  isLoading = false;
  type = '';

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private helperService: HelperService,
    private httpService: HTTPService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    const { type } = this.dialogConfig.data;
    this.type = type;
    this.getPrintLogs();
  }

  getPrintLogs = async () => {
    this.printLogs = await this.httpService.getPrintReportLogs(this.type);
    this.isLoading = true;
    this.printLogs.forEach((log) => {
      log.actionBy = this.renderName(log.actionBy);
      log.initial = this.helperService.fetchInitials(log.actionBy || '') || 'AL';
      log.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.listDT);
      log.text = log?.text || '';
    });
  };

  renderName = (name: string) => {
    if (name) {
      const [firstName, lastName] = name.split(' ');
      return `${firstName} ${this.helperService.fetchInitials(lastName)}`;
    }
    return '';
  };

  closeModal = () => {
    this.dynamicDialogRef.close({
      isSuccess: false,
    });
  };

  getLogsStatus(log) {
    let title = '';
    if (log.entityType === 'salesReport') {
      title = `printed the sales report`;
    } else if (log.entityType === 'dailyPaymentReport') {
      title = `printed the daily report`;
    } else if (log.entityType === 'taxSummaryItemsReports') {
      title = `printed the tax summary - items report`;
    } else if (log.entityType === 'royaltyReport') {
      title = log?.text ? log?.text?.replace(/<b>.*?<\/b>/, "")?.trim() : '';
    }
    return title;
  }

}
